import React from 'react';
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { TrackingOrder } from '../../../../models/TrackingOrder';
import dateFormat from 'dateformat';

interface PrintOrderProps {
    order: TrackingOrder;
    dmQrImage: string;
    subDmQrImage?: string | null;
    custQrImage: string;
}

const PrintOrder: React.FC<PrintOrderProps> = ({ order, dmQrImage, subDmQrImage, custQrImage }) => {
    const styles = StyleSheet.create({
        page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5 },
        reportTitle: { fontSize: 16, textAlign: 'center', marginBottom: 20 },
        section: { marginTop: 16 },
        sectionTitle: { fontSize: 12, fontStyle: 'bold', marginBottom: 8 },
        row: { flexDirection: 'row', marginBottom: 4 },
        label: { width: 120, fontWeight: 'bold' },
        value: { flex: 1 },
        qrRow: { flexDirection: 'row', justifyContent: 'space-around', marginTop: 24 },
        qrBox: { alignItems: 'center' },
        qrLabel: { fontSize: 10, marginBottom: 4 },
        qrCode: { width: 80, height: 80 },
        theader: { flexDirection: 'row', marginTop: 12, fontSize: 10, fontStyle: 'bold', backgroundColor: '#DEDEDE', padding: 4 },
        tbody: { flexDirection: 'row', fontSize: 9, padding: 4, borderBottomWidth: 1, borderColor: '#eee' },
        col1: { width: 30 }, col2: { flex: 2 }, col3: { width: 60 }, col4: { width: 60 },
    });

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Text style={styles.reportTitle}>Global Pharma Sdn. Bhd. - Tracking Order</Text>
                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>Order Information</Text>
                    <View style={styles.row}><Text style={styles.label}>Reference:</Text><Text style={styles.value}>{order.reference_no}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Delivery Number:</Text><Text style={styles.value}>{order.delivery_number || '-'}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Customer:</Text><Text style={styles.value}>{order.customer_fullname || '-'}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Date:</Text><Text style={styles.value}>{dateFormat(order.document_date || order.created_time, "mmmm dd, yyyy")}</Text></View>
                </View>
                {order.items && order.items.length > 0 && (
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Items</Text>
                        <View style={styles.theader}>
                            <Text style={styles.col1}>#</Text>
                            <Text style={styles.col2}>Description</Text>
                            <Text style={styles.col3}>Qty</Text>
                            <Text style={styles.col4}>UOM</Text>
                        </View>
                        {order.items.map((item, idx) => (
                            <View style={styles.tbody} key={idx}>
                                <Text style={styles.col1}>{idx + 1}</Text>
                                <Text style={styles.col2}>{item.is_other ? item.description : (item.product_description || item.item_no || '-')}</Text>
                                <Text style={styles.col3}>{item.quantity}</Text>
                                <Text style={styles.col4}>{item.uom || '-'}</Text>
                            </View>
                        ))}
                    </View>
                )}
                <View style={styles.qrRow}>
                    <View style={styles.qrBox}>
                        <Text style={styles.qrLabel}>Scan for Delivery Man</Text>
                        <Image style={styles.qrCode} src={dmQrImage} />
                    </View>
                    {subDmQrImage && (
                        <View style={styles.qrBox}>
                            <Text style={styles.qrLabel}>Scan for Sub-Delivery</Text>
                            <Image style={styles.qrCode} src={subDmQrImage} />
                        </View>
                    )}
                    <View style={styles.qrBox}>
                        <Text style={styles.qrLabel}>Scan for Customer</Text>
                        <Image style={styles.qrCode} src={custQrImage} />
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default PrintOrder;
